<template>
  <div class="search-product">
    <b-button v-b-modal.modal-search class="btn-search" v-if="!isLookup">
      <ThemifyIcon icon="search" />
    </b-button>

    <b-modal
      id="modal-search"
      hide-footer
      centered
      title="Produit"
      ref="soldproduct"
      style="position: relative"
    >
      <GStockLoader :loading="loading" />
      <form v-on:submit.prevent="getProduct" style="margin-bottom: 25px">
        <base-input
          alternative
          placeholder="Référence du produit"
          input-classes="form-control-alternative"
          v-model="ref"
          ref="searchbox"
        />
      </form>
      <div v-if="elem">
        <b-card no-body class="overflow-hidden" style="max-width: 540px">
          <b-row no-gutters>
            <b-col md="12">
              <b-card-body>
                <b-card-text class="highlighted"
                  >Article : {{ elem.name }}</b-card-text
                >
                <b-card-text class="highlighted"
                  >Prix : {{ elem.price + " DT" }}</b-card-text
                >
                 <b-card-text class="highlighted"
                  >Crédit : {{ elem.credit ? 'Oui' : 'Non' }}</b-card-text
                >
                <b-card-text>Déposant: {{ elem.client.name }}</b-card-text>
                <b-card-text
                  >Date de depot :
                  {{ $options.filters.date(elem.createdOn) }}</b-card-text
                >
                <b-card-text
                  >Statut :
                  {{
                    elem.purchased == 1 && elem.canceled == 0
                      ? "Vendu"
                      : elem.canceled == 1
                      ? "Annulé"
                      : "Disponible"
                  }}</b-card-text
                >
                <div v-if="elem.attributes">
                  <div
                    v-for="(attr, ind) in elem.attributes.split(';')"
                    :key="ind"
                  >
                    {{ attr.split("(:)")[0] }} : {{ attr.split("(:)")[1] }}
                  </div>
                </div>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <base-input
          v-if="elem ? elem.purchased == 0 && elem.canceled == 0 : false"
          alternative
          label="Prix"
          placeholder="Prix"
          input-classes="form-control-alternative"
          v-model="purchase.price"
        />
        <center>
          <b-btn
            v-if="elem ? elem.purchased == 0 : false"
            type="submit"
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
              margin-top: 10px;
            "
            @click="isLookup ? returnProduct($event) : postProduct($event)"
            >{{ isLookup ? "Ajouter" : "Vendre" }}</b-btn
          >
        </center>
      </div>
    </b-modal>
  </div>
</template>
<script>
import ThemifyIcon from "vue-themify-icons";
import GStockLoader from "@/components/Loader";
import { get, post, del } from "@/mixins/api";
import { EventBus } from "@/events/event-bus";
export default {
  components: {
    ThemifyIcon,
    GStockLoader,
  },
  props: {
    isLookup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      ref: "",
      elem: undefined,
      clients: [],
      purchase: {
        client: null,
      },
      loading: false,
    };
  },
  methods: {
    getProduct() {
      if (this.ref.indexOf(")") > 0) {
        this.ref = this.ref.substring(1, this.ref.indexOf(")"));
      }
      this.loading = true;
      get("product/" + this.ref)
        .then((res) => {
          this.elem = res.data.data;
          this.purchase.price = this.elem.price;
          if (this.isLookup) this.returnProduct(this.elem);
        })
        .catch((err) => (this.elem = undefined))
        .finally(() => {
          this.ref = "";
          this.loading = false;
        });
    },
    getClients() {
      get("clients").then((response) => {
        this.clients = response.data.data.map((it) => {
          return { text: it.fullname, value: it.id };
        });
      });
    },
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Ajout produit.",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
    openProduct(id) {
      this.$refs.soldproduct.show();
      this.ref = id + "";
      this.getProduct();
    },
    showModal() {
      this.$refs.soldproduct.show();
      this.$nextTick(function () {
        setTimeout(() => {
          this.$refs.searchbox.focusInput();
        }, 500);
      });
    },
    returnProduct() {
      const price = parseFloat(this.purchase.price);
      const product = { ...this.elem, price };
      this.$parent.addProduct(product);
      this.elem = undefined;
      this.ref = 0;
      this.$refs.soldproduct.hide();
    },
    postProduct(e) {
      e.stopPropagation();
      try {
        const price = parseFloat(this.purchase.price);
        if (price == 0) {
          this.makeToast("Veuillez choisir un client.");
        } else {
          const payload = {
            product: this.elem.id,
            price: price,
          };
          this.loading = true;
          post("purchase", payload)
            .then((res) => {
              this.makeToast(
                "Produit vendu. Un SMS est envoyé au proprietaire du produit.",
                "success"
              );
              this.elem = undefined;
              this.ref = 0;
              this.$refs.soldproduct.hide();
            })
            .catch((err) =>
              this.makeToast("Une erreur est survenue merci de résseayez.")
            )
            .finally(() => {
              this.loading = false;
            });
        }
      } catch (e) {
        this.makeToast("Vérifiez les données que vous avez saisit.");
      }
    },
  },
  filters: {
    date: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const tmp = date.toLocaleDateString("fr-FR", { weekday: "long" });
      const day = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      const month = date.toLocaleString("fr-FR", { month: "long" });
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      let currentHour = date.getHours() + "";
      let currentMinute = date.getMinutes() + "";
      if (currentHour.length < 2) currentHour = "0" + currentHour;
      if (currentMinute.length < 2) currentMinute = "0" + currentMinute;
      return (
        day +
        " " +
        dayOfMonth +
        " " +
        month +
        " " +
        year +
        ", " +
        currentHour +
        ":" +
        currentMinute
      );
    },
  },
  mounted() {
    this.getClients();
  },
};
</script>
<style lang="scss">
.highlighted {
  font-size: 20px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  font-weight: bold;
}
.btn-search {
  display: flex !important;
  justify-content: center;
  align-items: center;
  border-radius: 50% !important;
  font-size: 30px !important;
  font-weight: bold !important;
  width: 70px;
  height: 70px;
  color: #fff !important;
  background: #000 !important;
  .ti-search {
    display: inline;
  }
}
#modal-search {
  .modal-body,
  .modal-header {
    padding: 10px !important;
  }
  .form-group {
    padding-top: 0px !important;
    margin-bottom: 0px !important;
  }
}
.card-body {
  margin-top: 15px;
  padding: 10px;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.modal-header .close {
  margin: 0px;
  padding: 0px;
}
</style>
